// extracted by mini-css-extract-plugin
export default {"componentWrapper":"ManagmentPanelLayout_componentWrapper__PVsZI","content":"ManagmentPanelLayout_content__F-Wh3"};